module.exports = __webpack_public_path__ + "img/feather.4786a413.svg";